module.exports = __webpack_public_path__ + "img/2_1.e5f18c0f.jpg";